// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".JO5X0mHqupVgK6RH976XZw\\=\\={margin:1px 0 0 5px}", "",{"version":3,"sources":["webpack://./resources/js/components/AppHeader/TopHeader/styles.module.scss"],"names":[],"mappings":"AAAA,4BACI,kBACJ","sourcesContent":[".dropdown_icon {\n    margin: 1px 0 0 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown_icon": "JO5X0mHqupVgK6RH976XZw=="
};
export default ___CSS_LOADER_EXPORT___;
